/* eslint-disable */
import {
	Button,
	Dialog,
	DialogContent,
	DialogTitle,
	Grid,
	IconButton,
	Paper,
	TextField,
	Tooltip,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Box } from "@mui/system";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import SearchIcon from "@mui/icons-material/Search";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import { useEffect, useState } from "react";
import { getTratamientos } from "../../../project/services/TratamientoService";
import Message from "../../../project/utils/Message";
import WaitingDialog from "../../utils/WaitingDialog";

const initialSearchData = {
	descripcion: "",
};
//
// ################################################################################
//
const BuscarTratamientoDialog = ({ open, onClose, onSelect }) => {
	const [searchData, setSearchData] = useState(initialSearchData);
	const [articulos, setArticulos] = useState([]);
	const [isDoingSomething, setIsDoingSomething] = useState(false);
	const [message, setMessage] = useState({});
	const [showMessage, setShowMessage] = useState(false);
	const [totalRowsCount, setTotalRowsCount] = useState(0);
	const [currentPage, setCurrentPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);

	const tableColumns = [
		{
			field: "codigo",
			headerName: "Código",
			headerAlign: "center",
			align: "center",
			flex: 1,
			sortable: false,
			renderCell: (params) => {
				let _val = params.row.codigo;
				_val = _val ? _val.toUpperCase() : "";
				return _val;
			},
		},
		{
			field: "descripcion",
			headerName: "Descripción",
			headerAlign: "center",
			align: "left",
			flex: 5,
			sortable: false,
			renderCell: (params) => {
				let _val = params.row.descripcion;
				_val = _val ? _val.toUpperCase() : "";
				return _val;
			},
		},
		{
			field: "precio_venta_lista",
			headerName: "Prc Venta",
			headerAlign: "center",
			align: "right",
			flex: 1,
			type: "number",
			sortable: false,
			renderCell: (params) => {
				let _val = params.row.precio_venta_lista.toFixed(2);
				_val = _val ? _val : "";
				return _val;
			},
		},
		{
			field: "actions",
			headerName: "Seleccionar",
			headerAlign: "center",
			align: "left",
			flex: 1,
			sortable: false,
			filterable: false,
			renderCell: (params) => (
				<>
					{params.row.cu !== "view" && (
						<Tooltip title="seleccionar">
							<IconButton
								size="small"
								aria-label="update"
								onClick={() => handleRowClick(params.row)}
							>
								<CheckIcon />
							</IconButton>
						</Tooltip>
					)}
				</>
			),
		},
	];

	const handlePaginationModelChange = (newModel) => {
		setCurrentPage(newModel.page);
		setRowsPerPage(newModel.pageSize);
	};

	const tableOptions = {
		paginationMode: "server",
		rowCount: totalRowsCount,
		paginationModel: {
			page: currentPage,
			pageSize: rowsPerPage,
		},
		onPaginationModelChange: handlePaginationModelChange,
		pageSizeOptions: [10, 20, 30],
		disableRowSelectionOnClick: true,
		disableColumnMenu: true,
		disableColumnFilter: true,
		disableColumnSelector: true,
		disableDensitySelector: true,
		localeText: {
			noRowsLabel: "",
			noResultsOverlayLabel: "",
			MuiTablePagination: {
				labelRowsPerPage: "Filas:",
				labelDisplayedRows: ({ from, to, count }) =>
					`${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`,
			},
		},
		sx: {
			"& .MuiDataGrid-cell": {
				fontSize: "0.9em",
			},
			"& .MuiDataGrid-columnHeaders": {
				backgroundColor: "#f5f5f5",
			},
		},
	};
	//
	// ################################################################################
	//
	useEffect(() => {
		load();
	}, [currentPage, rowsPerPage]);
	//
	// ################################################################################
	//
	const handleChange = (e) => {
		setSearchData({
			...searchData,
			[e.target.name]: e.target.value,
		});
	};
	//
	// ################################################################################
	//
	const handleLimpiar = () => {
		setSearchData(initialSearchData);
	};
	//
	// ################################################################################
	//
	const handleBuscar = () => {
		load();
	};
	//
	// ################################################################################
	//
	const load = async () => {
		let _params = {
			descripcion: searchData.descripcion,
			rows: rowsPerPage,
			first: currentPage * rowsPerPage,
		};

		setIsDoingSomething(true);
		const response = await getTratamientos(_params);
		setIsDoingSomething(false);

		if (response.ok) {
			setTotalRowsCount(response.data.count);
			setArticulos(response.data.data);
		} else {
			setMessage({
				messageText: response.messageText,
				severity: response.messageSeverity,
			});
			setShowMessage(true);
		}
	};
	//
	// ################################################################################
	//
	const handleRowClick = (parRow) => {
		onSelect(parRow);
	};
	//
	// ################################################################################
	//
	const handleCloseDialog = () => {
		onClose();
	};
	//
	// ################################################################################
	//
	return (
		<>
			<Dialog
				open={open}
				onClose={handleCloseDialog}
				maxWidth="lg"
				fullWidth={true}
				scroll="paper"
				aria-labelledby="form-dialog-title"
			>
				<DialogTitle id="form-dialog-title">
					Búsqueda de Tratamientos
					<IconButton
						aria-label="close"
						onClick={onClose}
						sx={{
							position: "absolute",
							right: 8,
							top: 8,
							color: (theme) => theme.palette.grey[500],
						}}
					>
						<CloseIcon />
					</IconButton>
				</DialogTitle>

				<DialogContent dividers>
					<Box>
						<Grid container spacing={1} sx={{ pb: 1 }}>
							<Grid item xs={12}>
								{/* Descripcion */}

								<TextField
									sx={{ width: "100%" }}
									variant="outlined"
									size="small"
									name="descripcion"
									label="Descripción"
									value={searchData.descripcion}
									onChange={handleChange}
								/>
							</Grid>
						</Grid>
					</Box>

					<Box sx={{ mb: 1, float: "right" }}>
						{/* Buscar */}

						<Button
							sx={{ mr: 1 }}
							variant="contained"
							onClick={handleBuscar}
							startIcon={<SearchIcon />}
						>
							Buscar
						</Button>

						{/* Limpiar */}

						<Button
							sx={{ mr: 1 }}
							variant="outlined"
							onClick={handleLimpiar}
							startIcon={<CleaningServicesIcon />}
						>
							Limpiar
						</Button>
					</Box>

					<Paper
						sx={{
							width: "100%",
							overflow: "hidden",
							border: "1px solid LightGrey",
						}}
					>
						<DataGrid
							rows={articulos}
							columns={tableColumns}
							{...tableOptions}
						/>
					</Paper>
				</DialogContent>
			</Dialog>

			{/* >>>> Messages */}

			{showMessage && (
				<Message
					showMessage={showMessage}
					setShowMessage={setShowMessage}
					message={message}
				/>
			)}

			<WaitingDialog open={isDoingSomething} />
		</>
	);
};
export default BuscarTratamientoDialog;
